import {FC, useCallback, useMemo} from 'react';
import {api, IDocumentInfo, useT, IDocumentQueueActions} from '@kcast-fe/core';
import {useDropzone} from 'react-dropzone';
import {Box} from '@chakra-ui/react';
import {Tooltip, EllipseButton} from 'ui-kit';
import {UPLOAD_ACCEPT, UPLOAD_MAX_BYTES, UPLOAD_IMG_ACCEPT} from 'core';

interface IProps {
  queueActions: IDocumentQueueActions;
  documentsQueue: IDocumentInfo[];
  isDisabled?: boolean;
}

const DOCUMENT_AMOUNT_MAX = 5;
const TOOLTIP_ID = 'DOCUMENT_AMOUNT_MAX';

export const AddDocumentButton: FC<IProps> = ({documentsQueue, isDisabled, queueActions}) => {
  const {data} = api.documents.useContextDocumentsQuery();

  const {t} = useT();

  const documentsAmount = useMemo(() => {
    return (data?.docs ?? []).length;
  }, [data?.docs]);

  const isMaxReached = useMemo(() => {
    return documentsAmount + documentsQueue.length >= DOCUMENT_AMOUNT_MAX;
  }, [documentsAmount, documentsQueue.length]);

  const onDrop = useCallback(
    (files: Array<File>) => {
      files.forEach((file) => {
        if (file.size <= UPLOAD_MAX_BYTES) {
          queueActions.doUpload(file);
        } else {
          //handleFileError(file, t('errors.docIsLarge', {name: file.name}), true);
        }
      });
    },
    [queueActions]
  );

  const {getRootProps, getInputProps} = useDropzone({
    accept: {...UPLOAD_IMG_ACCEPT, ...UPLOAD_ACCEPT},
    disabled: isDisabled,
    multiple: true,
    onDrop: onDrop
  });

  return (
    <Box {...getRootProps()} data-tooltip-id={TOOLTIP_ID} _hover={{cursor: 'pointer'}}>
      <EllipseButton icon={'Plus'} size={'normal'} iconSize={'s24'} variant={'transparent'} />

      <input {...getInputProps()} disabled={isDisabled || isMaxReached} />

      {isMaxReached && (
        <Tooltip id={TOOLTIP_ID} offset={2}>
          <Box>{t('messages.maxDocsReached')}</Box>
        </Tooltip>
      )}
    </Box>
  );
};
